/**
 * Предзагружает все изображения, используемые в приложении
 * для мгновенного отображения после выхода из прелоадера
 */
export const preloadImages = (): void => {
  // Список всех изображений, которые нужно предзагрузить
  const imagesToPreload = [
    // Логотип
    '/logo.svg',
    
    // Иконки навигации в Header
    '/icons/navigation/client.svg',
    '/icons/navigation/project.svg',
    '/icons/navigation/dela.svg',
    '/icons/navigation/zadachi.svg',
    '/icons/navigation/calendar.svg',
    '/icons/navigation/reports.svg',
    '/icons/navigation/admin.svg',
    
    // Иконки в Header
    '/icons/header/notification.svg',
    '/icons/header/settings.svg',
    
    // Аватар по умолчанию
    '/avatar.png',
  ];

  // Предзагружаем все изображения
  imagesToPreload.forEach((src) => {
    const img = new Image();
    img.src = src;
  });
};
